const RESIZE_OBSERVER_ERRORS = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
]

export const suppressResizeObserverError = () => {
  window.addEventListener('error', event => {
    if (RESIZE_OBSERVER_ERRORS.includes(event.message)) {
      event.stopImmediatePropagation()
    }
  })
}
